angular.module('FlexyBeautyApp.services')
    .factory('MonitoringUsageData_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/monitoring/' , {} ,
            {
                logUsageData:   { method: 'POST', url: baseUrl + 'rest/monitoring/logUsageData'},
            }
        );
    }]);

angular.module('FlexyBeautyApp.services')
    .factory('MonitoringUsageDataSrv',["MonitoringUsageData_Resource",
            function (MonitoringUsageData_Resource) {
               let monitoringUsageDataSrv = {};
               monitoringUsageDataSrv.logUsageData= function (data) {
                    let monitoringUsageDataResource = new MonitoringUsageData_Resource();
                    monitoringUsageDataResource.data = data;
                    monitoringUsageDataResource.$logUsageData({});
                    return Promise.resolve();
               };

            return monitoringUsageDataSrv;
   }]);
angular.module('FlexyBeautyApp.services')
    .factory('MonitoringUsageConstants', [function (gettextCatalog) {
        return {
            STATISTICS : "CLICK_COUNT_TAB_STATISTICS",
            SALES_TURNOVER : "ACCOUNTING_DATA - CLICK_COUNT_SALES_TURNOVER",
            PAYMENTS : "ACCOUNTING_DATA - CLICK_COUNT_PAYMENTS",
            GIFT_CARDS : "ACCOUNTING_DATA - CLICK_COUNT_GIFT_CARDS",
            PETTY_CASH_FUND : "ACCOUNTING_DATA - CLICK_COUNT_PETTY_CASH_FUND",
            EXPORT: "ACCOUNTING_DATA - CLICK_COUNT_EXPORT"
        };
    }]);


// WEBPACK FOOTER //
// ./js/services/aspect/UsageAspect.js